<template>
  <div class="home container flex flex_wrap">
    <!-- <iframe
      src="http://192.168.1.200/chatbot/wCFATS1vOmdGWnaV"
      style="width: 100%; height: 100%; min-height: 700px"
      frameborder="0"
      allow="microphone"
    >
    </iframe> -->
    <div
      :class="['module', item.flex == 0.5 ? 'my_card' : '']"
      v-for="(item, index) in homeModules"
      :key="index"
      :style="getModuleStyle(item)"
    >
      <commonTitleVue
        :title="item.moduleName"
        @moreClick="moreClick(item)"
        :showMore="item.showMore"
      />
      <div class="content">
        <component
          :is="item.childComName"
          :list="item.children"
          :pieData="pieData"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitleVue from "@/components/commonTitle.vue";
import cydtCom from "./child/cydt.vue";
import qyzxCom from "./child/qyzx.vue";
import xxzlCom from "./child/xxzl.vue";
import zcfgCom from "./child/zcfg.vue";
import hybzCom from "./child/hybz.vue";
import yyzjCom from "./child/yyzj.vue";
import qyxxCom from "./child/qyxx.vue";
import qklwCom from "./child/qklw.vue";

import { searchModuleDataListApi } from "@/apis/api";
import { getComPersonResearchCounts } from "@/utils/commonMethods";
export default {
  name: "WorkspaceJsonIndex",
  components: {
    commonTitleVue,
    cydtCom,
    qyzxCom,
    xxzlCom,
    zcfgCom,
    hybzCom,
    yyzjCom,
    qyxxCom,
    qklwCom,
  },
  data() {
    return {
      homeModules: [
        {
          moduleName: "产业地图",
          showMore: true,
          childComName: "cydtCom",
          flex: 1,
          listPath: "/industryAnalysis",
        },
        {
          moduleName: "前沿资讯",
          showMore: true,
          childComName: "qyzxCom",
          flex: 1,
          moduleCode: "medical_news_info",
          children: [],
          listPath: "/list?moduleCode=medical_search_news",
        },
        {
          moduleName: "信息专栏",
          showMore: false,
          childComName: "xxzlCom",
          flex: 1,
        },
        {
          moduleName: "政策法规",
          showMore: true,
          childComName: "zcfgCom",
          flex: 0.5,
          moduleCode: "medical_policy_info",
          children: [],
          listPath: "/list?moduleCode=medical_search_policy",
        },
        {
          moduleName: "行业标准",
          showMore: true,
          childComName: "hybzCom",
          flex: 0.5,
          moduleCode: "medical_standard_info",
          children: [],
          listPath: "/list?moduleCode=medical_search_standard",
        },
        {
          moduleName: "医药专家",
          showMore: true,
          childComName: "yyzjCom",
          flex: 0.5,
          moduleCode: "medical_author_info",
          children: [],
          listPath: "/expertList",
        },
        {
          moduleName: "企业信息",
          showMore: true,
          childComName: "qyxxCom",
          flex: 0.5,
          moduleCode: "medical_org_info",
          children: [],
          listPath: "/orgList",
        },
        {
          moduleName: "学术期刊",
          showMore: true,
          childComName: "qklwCom",
          flex: 1,
          moduleCode: "medical_journalI_info",
          children: [],
          listPath: "/qkList",
        },
      ],
      updateInfo: {},
      pieData: [
        /* {
          label: "医药企业",
          moduleCode: ["medical_search_org"],
          count: 0,
          unit: "家",
          color: "#409EFF",
        },
        {
          label: "高端人才",
          moduleCode: ["medical_search_author"],
          count: 0,
          unit: "人",
          color: "#67C23A",
        },
        {
          label: "科技成果",
          moduleCode: [
            "medical_search_journal_paper",
            "medical_search_report",
            "medical_search_standard",
            "medical_search_patent",
          ],
          count: 0,
          unit: "个",
          color: "#E6A23C",
        }, */
      ],
    };
  },

  async mounted() {
    this.init();
  },

  methods: {
    async init() {
      /* 先进行统计后再获取模块数据 */
      /* let res = await getUpdateInfoApi();
      this.updateInfo = res?.data || {};
      this.pieData.forEach((item) => {
        item.moduleCode.forEach((m) => {
          item.count += this.updateInfo[m]?.count || 0;
        });
      }); */
      this.pieData = await getComPersonResearchCounts();
      // return;
      let modules = this.homeModules.filter((item) => item.moduleCode);
      modules.forEach(async (item) => {
        let res = await searchModuleDataListApi({
          moduleCode: item.moduleCode,
        });
        console.log(res, "sssssssss");
        item.children = res?.data?.data?.hits || [];
      });
    },
    getModuleStyle({ flex }) {
      return {
        width: `calc(${flex} * 100% - 20px)`,
        padding: flex == 0.5 ? "20px 28px" : "0",
      };
    },
    moreClick(item) {
      console.log(item);
      const { childComName, listPath, moduleName } = item;
      if (!listPath) return;
      let path = listPath;
      if (childComName == "zcfgCom") {
        let advArr = [
          {
            field: ["category.raw"],
            key: "政策法规",
            searchType: 2,
            operType: 1,
            tagName: moduleName,
          },
        ];
        let adv = encodeURIComponent(JSON.stringify(advArr));
        path = listPath + `&adv=${adv}`;
      }
      if (childComName == "qyxxCom") {
        let advArr = [
          {
            field: ["org_type"],
            key: "2",
            searchType: 2,
            operType: 1,
            tagName: moduleName,
          },
        ];
        let adv = encodeURIComponent(JSON.stringify(advArr));
        path = `/orgList?adv=${adv}`;
      }
      this.$router.push(path);
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  padding-top: 20px;
  .module {
    margin: 0 10px;
    margin-bottom: 20px;
    .content {
      padding-top: 20px;
    }
  }
}
</style>